export const ADMIN_ROLES = {
  SUPER_ADMIN: 'super_admin',
  FINANCE_ADMIN: 'finance_admin',
  SUPPORT_AGENT: 'support_agent',
} as const;

export const ADMIN_ROLE_LABELS: Record<string, string> = {
  super_admin: 'Super Admin',
  finance_admin: 'Finance Admin',
  support_agent: 'Support Agent',
};

export const PLAN_LABELS: Record<string, string> = {
  trial: 'Trial',
  starter: 'Starter',
  growth: 'Growth',
  pro: 'Pro',
  business: 'Business',
};

export const SUBSCRIPTION_STATUS_COLORS: Record<string, string> = {
  active: 'green',
  trialing: 'blue',
  past_due: 'orange',
  canceled: 'red',
  unpaid: 'red',
  incomplete: 'gold',
  incomplete_expired: 'default',
  paused: 'default',
};

export const TICKET_STATUS_COLORS: Record<string, string> = {
  open: 'blue',
  in_progress: 'gold',
  waiting_on_customer: 'orange',
  resolved: 'green',
  closed: 'default',
};

export const TICKET_PRIORITY_COLORS: Record<string, string> = {
  low: 'default',
  medium: 'blue',
  high: 'orange',
  urgent: 'red',
};
